import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Trophy, Flame, Award } from "lucide-react";

export function GamificationCard() {
  const [g, setG] = useState(null);
  useEffect(() => { (async () => { try { const { data } = await api.get("/gamification/me"); setG(data); } catch { /* ignore */ } })(); }, []);
  if (!g) return null;
  return (
    <div className="bg-gradient-to-br from-blue-600 to-blue-700 text-white rounded-xl p-6">
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-bold text-lg">Your progress</h3>
        <Trophy className="h-5 w-5" />
      </div>
      <div className="mt-4 grid grid-cols-3 gap-4">
        <Stat icon={Trophy} label="XP" value={g.xp} />
        <Stat icon={Flame} label="Streak" value={`${g.streak}d`} />
        <Stat icon={Award} label="Badges" value={`${g.badges_earned.length}/${g.all_badges.length}`} />
      </div>
      <div className="mt-5 flex flex-wrap gap-2">
        {g.all_badges.map((b) => {
          const earned = g.badges_earned.find((x) => x.id === b.id);
          return (
            <span key={b.id}
              data-testid={`badge-${b.id}`}
              title={`${b.name} — ${b.desc}`}
              className={`text-xs font-semibold px-2 py-1 rounded-full inline-flex items-center gap-1 ${earned ? "bg-yellow-300 text-slate-900" : "bg-blue-700/60 text-blue-100"}`}>
              <span>{b.icon}</span> {b.name}
            </span>
          );
        })}
      </div>
    </div>
  );
}

function Stat({ icon: Icon, label, value }) {
  return (
    <div>
      <div className="flex items-center gap-1 text-blue-100 text-xs font-bold uppercase tracking-wider">
        <Icon className="h-3.5 w-3.5" /> {label}
      </div>
      <div className="mt-1 font-heading font-black text-2xl">{value}</div>
    </div>
  );
}
